function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 8.0503,
  cy: 8.0503,
  r: 6,
  transform: "translate(-3.3345 8.0503) rotate(-45)",
  style: {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.2929,
  y1: 12.2929,
  x2: 17.9497,
  y2: 17.9497,
  style: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }
}));
export default SvgSearch;